import confsService from '@/api/confsService'
import { CHANNEL_OPTIONS, CHANNEL_OPTIONS_EXTERIOR } from '@/utils/campaignOptions'

let contactsRaw = {}
Object.values({ ...CHANNEL_OPTIONS, ...CHANNEL_OPTIONS_EXTERIOR }).map((co, index) => {
  contactsRaw[co] = {
    name: `newContact-${co}`,
    value: ''
  }
})

let contactsListRaw = {}
Object.values({ ...CHANNEL_OPTIONS, ...CHANNEL_OPTIONS_EXTERIOR }).map((co, index) => {
  contactsListRaw[co] = []
})

/**
 *  ConfForm script file
**/

export default {
  name: 'ConfForm',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      conf: {},
      channelTypes: Object.values({ ...CHANNEL_OPTIONS, ...CHANNEL_OPTIONS_EXTERIOR }),
      newContacts: contactsRaw,
      contacts: contactsListRaw,
      newGAWAccount: '',
      newAgencyExteriorEmail: '',
      gawAccounts: [],
      newTerrUnit: '',
      terrUnits: [],
      exteriorAgencyEmails: []
    }
  },
  async mounted () {
    this.$emit('selectTab', { id: 'confs' })

    if (this.$route.params.confid) {
      this.conf = await confsService.getConf({ id: this.$route.params.confid })
      if (this.conf.profile.emails) {
        Object.keys(this.conf.profile.emails).forEach(type => {
          this.contacts[type] = this.conf.profile.emails[type].split(',')
        })
      }
      if (this.conf.profile.gaw_extra_accounts) {
        this.gawAccounts = this.conf.profile.gaw_extra_accounts
      }
      if (this.conf.profile.terr_units) {
        this.terrUnits = this.conf.profile.terr_units
      }
      if (this.conf.profile.exterior_agency_emails) {
        this.exteriorAgencyEmails = this.conf.profile.exterior_agency_emails
      }
    }
  },
  computed: {
  },
  methods: {
    closeModal () {
      this.$router.push('/administration')
    },
    updateScrollbar () {
      window.setTimeout(() => {
        if (this.$refs.scrollbar) this.$refs.scrollbar.update()
      }, 250)
    },
    addContact (type) {
      if (!this.newContacts[type].value) {
        return
      }
      this.contacts[type].push(this.newContacts[type].value)
      this.newContacts[type].value = ''
    },
    removeContact (type, contact) {
      this.contacts[type] = this.contacts[type].filter(item => item !== contact)
    },
    addGAWAccount () {
      if (!this.newGAWAccount) {
        return
      }
      this.gawAccounts.push(this.newGAWAccount)
      this.newGAWAccount = ''
    },
    removeGAWAccount (account) {
      this.gawAccounts = this.gawAccounts.filter(item => item !== account)
    },
    addTerrUnit () {
      if (!this.newTerrUnit) {
        return
      }
      this.terrUnits.push(this.newTerrUnit)
      this.newTerrUnit = ''
    },
    removeTerrUnit (terrUnit) {
      this.terrUnits = this.terrUnits.filter(item => item !== terrUnit)
    },
    addAgencyExteriorEmail () {
      if (!this.newAgencyExteriorEmail) {
        return
      }
      this.exteriorAgencyEmails.push(this.newAgencyExteriorEmail)
      this.newAgencyExteriorEmail = ''
    },
    removeAgencyExteriorEmail (email) {
      this.exteriorAgencyEmails = this.exteriorAgencyEmails.filter(item => item !== email)
    },
    async save () {
      let emails = {}
      Object.keys(this.contacts).map(c => {
        emails[c] = this.contacts[c].join()
      })
      const body = {
        // emails: emails,
        gaw_accounts: this.gawAccounts,
        terr_units: this.terrUnits,
        // exterior_agency_emails: this.exteriorAgencyEmails,
        facebook_token: this.conf.profile.facebook_token
      }

      try {
        await confsService.editConf({ id: this.$route.params.confid, ...body })
        this.$router.push({ path: `/administration/conf/${this.$route.params.confid}` })
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[conf-form.js] Error saving new conf', err)
      }
    }
  }
}
